import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgrxFormsModule } from 'ngrx-forms';
import { AnimateCssDirective } from 'src/app/directives/animatecss.directive';
import { environment } from 'src/environments/environment';
import {
  MatProgressSpinner,
  MatProgressSpinnerModule,
} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-member-join-offline',
  templateUrl: './member-join-offline.component.html',
  styleUrls: ['./member-join-offline.component.scss'],
  imports: [
    NgClass,
    NgIf,
    MatProgressBarModule,
    NgrxFormsModule,
    ReactiveFormsModule,
    FormsModule,
    AnimateCssDirective,
    MatProgressSpinner,
    MatProgressSpinnerModule,
  ],
})
export class MemberJoinOfflineComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  @HostListener('window:resize', ['$event'])
  onResize(_event) {
    this.innerWidth = window.innerWidth;
  }
  public innerWidth: any;
  offlineRegisterFormLink: string = '';
  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.innerWidth = window.innerWidth;
    this.offlineRegisterFormLink = environment.offlineRegisterFormLink;

    setTimeout(() => {
      window.location.href = environment.offlineRegisterFormLink;
    }, 1500);
  }

  ngOnDestroy(): void {
    super.ngOnDestroyBase();
  }
}
